import {
    INidusClient,
    NidusEntry,
    NidusEntryData,
    NidusEntryId,
    NidusName,
    NidusReferenceKey,
    NidusSearchResponse,
} from "../INidusClient";

import { IContextualNidusClient } from "./IContextualNidusClient";

export class ContextualNidusClient implements IContextualNidusClient {
    private readonly innerClient: INidusClient;
    private readonly nidusName: NidusName;
    private readonly key: NidusReferenceKey;

    public constructor(innerClient: INidusClient, nidusName: NidusName, key: NidusReferenceKey) {
        this.innerClient = innerClient;
        this.nidusName = nidusName;
        this.key = key;
    }

    public batchInsert(objects: NidusEntry[]): Promise<void> {
        return this.innerClient.batchInsert(this.nidusName, this.key, objects);
    }

    public delete(objectId: NidusEntryId): Promise<void> {
        return this.innerClient.delete(this.nidusName, this.key, objectId);
    }

    public insert(obj: NidusEntryData): Promise<NidusEntry> {
        return this.innerClient.insert(this.nidusName, this.key, obj);
    }

    public search(searchValue: string | null | undefined): Promise<NidusSearchResponse> {
        return this.innerClient.search(this.nidusName, this.key, searchValue);
    }

    public update(objectId: NidusEntryId, obj: NidusEntryData): Promise<void> {
        return this.innerClient.update(this.nidusName, this.key, objectId, obj);
    }
}
